import { WebsiteSection } from '../../types/sections';
import { SectionId } from '../../types/websiteConfiguration';

export const isSectionFixed = (section: WebsiteSection) => !!section?.static;

export const shouldDisableSection = (section: WebsiteSection, enabledSections: SectionId[]) => {
  if (section._id === 'learn-more' && !enabledSections.includes('hero-block')) {
    return true;
  }

  return false;
};
